import { CountryCode } from '@src/types/common';

export interface PendingReason {
  id: number;
  name: string;
}

export interface PendingReasonsByCountry {
  [key: string]: PendingReason[];
}

// Razones pendientes por país
export const PENDING_REASONS_BY_COUNTRY: PendingReasonsByCountry = {
  [CountryCode.CRC]: [
    // Costa Rica
    { id: 1, name: 'Falta FUD' },
    { id: 2, name: 'FUD mal diligenciado' },
    { id: 3, name: 'Falta colilla de tránsito' },
    { id: 4, name: 'Falta licencia del asegurado' },
    { id: 5, name: 'Faltan fotos de documentos del asegurado' },
    { id: 6, name: 'Faltan fotos del vehículo asegurado' },
    { id: 7, name: 'Faltan fotos de documentos de la contraparte' },
    { id: 8, name: 'Faltan fotos del vehículo de la contraparte' },
    { id: 9, name: 'Falta foto del VIN y odómetro' },
    { id: 10, name: 'Falta parte trasera de la licencia' },
    { id: 11, name: 'Resolución del inspector no es clara' },
    { id: 12, name: 'Información del SIC no coincide con los documentos' },
    { id: 13, name: 'Faltan fotos panorámicas' },
    { id: 14, name: 'Falta firma del inspector' },
    { id: 15, name: 'Relato incoherente' },
    { id: 16, name: 'Falta el relato de los hechos' },
    { id: 17, name: 'Falta observación del inspector' },
    { id: 18, name: 'Falta daños del vehículo' },
  ],
  [CountryCode.PAN]: [
    // Panamá
    { id: 101, name: 'Falta FUD' },
    { id: 102, name: 'FUD mal diligenciado' },
    { id: 103, name: 'Falta colilla de tránsito' },
    { id: 104, name: 'Falta licencia del asegurado' },
    { id: 105, name: 'Faltan fotos de documentos del asegurado' },
    { id: 106, name: 'Faltan fotos del vehículo asegurado' },
    { id: 107, name: 'Faltan fotos de documentos de la contraparte' },
    { id: 108, name: 'Faltan fotos del vehículo de la contraparte' },
    { id: 109, name: 'Falta foto del VIN y odómetro' },
    { id: 110, name: 'Falta parte trasera de la licencia' },
    { id: 111, name: 'Resolución del inspector no es clara' },
    { id: 112, name: 'Información del SIC no coincide con los documentos' },
    { id: 113, name: 'Faltan fotos panorámicas' },
    { id: 114, name: 'Falta firma del inspector' },
    { id: 115, name: 'Relato incoherente' },
    { id: 116, name: 'Falta el relato de los hechos' },
    { id: 117, name: 'Falta observación del inspector' },
    { id: 118, name: 'Falta daños del vehículo' },
  ],
  [CountryCode.PRI]: [
    // Puerto Rico
    { id: 201, name: 'Falta FUD' },
    { id: 202, name: 'FUD mal diligenciado' },
    { id: 203, name: 'Falta colilla de tránsito' },
    { id: 204, name: 'Falta licencia del asegurado' },
    { id: 205, name: 'Faltan fotos de documentos del asegurado' },
    { id: 206, name: 'Faltan fotos del vehículo asegurado' },
    { id: 207, name: 'Faltan fotos de documentos de la contraparte' },
    { id: 208, name: 'Faltan fotos del vehículo de la contraparte' },
    { id: 209, name: 'Falta foto del VIN y odómetro' },
    { id: 210, name: 'Falta parte trasera de la licencia' },
    { id: 211, name: 'Resolución del inspector no es clara' },
    { id: 212, name: 'Información del SIC no coincide con los documentos' },
    { id: 213, name: 'Faltan fotos panorámicas' },
    { id: 214, name: 'Falta firma del inspector' },
    { id: 215, name: 'Relato incoherente' },
    { id: 216, name: 'Falta el relato de los hechos' },
    { id: 217, name: 'Falta observación del inspector' },
    { id: 218, name: 'Falta daños del vehículo' },
  ],
  [CountryCode.COL]: [
    // Colombia
    { id: 301, name: 'Falta FUD' },
    { id: 302, name: 'FUD mal diligenciado' },
    { id: 303, name: 'Falta colilla de tránsito' },
    { id: 304, name: 'Falta licencia del asegurado' },
    { id: 305, name: 'Faltan fotos de documentos del asegurado' },
    { id: 306, name: 'Faltan fotos del vehículo asegurado' },
    { id: 307, name: 'Faltan fotos de documentos de la contraparte' },
    { id: 308, name: 'Faltan fotos del vehículo de la contraparte' },
    { id: 309, name: 'Falta foto del VIN y odómetro' },
    { id: 310, name: 'Falta parte trasera de la licencia' },
    { id: 311, name: 'Resolución del inspector no es clara' },
    { id: 312, name: 'Información del SIC no coincide con los documentos' },
    { id: 313, name: 'Faltan fotos panorámicas' },
    { id: 314, name: 'Falta firma del inspector' },
    { id: 315, name: 'Relato incoherente' },
    { id: 316, name: 'Falta el relato de los hechos' },
    { id: 317, name: 'Falta observación del inspector' },
    { id: 318, name: 'Falta daños del vehículo' },
  ],
};

export const getPendingReasonsByCountry = (
  countryCode: CountryCode,
): PendingReason[] => {
  return PENDING_REASONS_BY_COUNTRY[countryCode] || [];
};

export const getAllPendingReasons = (): PendingReason[] => {
  return Object.values(PENDING_REASONS_BY_COUNTRY).flat();
};

export const getPendingReasonById = (id: number): PendingReason | undefined => {
  return getAllPendingReasons().find((reason) => reason.id === id);
};

export default PENDING_REASONS_BY_COUNTRY;
